import React from 'react'
import { declineCounterOffer, declineOffer } from 'services/offersService';

const ReceivedOfferDecline = ({ id, cost, date, setStep, closeWindow, isCounter, refreshItems, playSound }) => {

  const declineHandler = () => {
    playSound('main');
    if(isCounter) {
      declineCounterOffer(id, setStep, refreshItems)
    } else {
      declineOffer(id, setStep, refreshItems);
    }
  }

  const formatData = (receivedDate) => {
    const date = new Date(receivedDate);

    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h24'
    }).replace(',', '')
  }

  return (
    <>
      <ul className="sell-card__info-list">
        <li className="sell-card__info-list-item">
          <span className="sell-card__info-list-item-title">Amount Offered</span>
          <b className="sell-card__info-list-item-value">${cost.toFixed(2)} USD</b>
        </li>
        <li className="sell-card__info-list-item">
          <span className="sell-card__info-list-item-title">Offer Submitted</span>
          <b className="sell-card__info-list-item-value">{formatData(date)}</b>
        </li>
        <li className="sell-card__info-list-item">
          <span className="sell-card__info-list-item-title">Transaction id</span>
          <b className="sell-card__info-list-item-value">{id}</b>
        </li>
      </ul>
      <footer className="sell-card__info-offer-options">
        <button onClick={closeWindow}>Cancel</button>
        <button className="accept" onClick={declineHandler}>Confirm</button>
      </footer>
    </>
  )
}

export default ReceivedOfferDecline;
